import { Button, Select, X } from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAppointmentFilters } from "../../../hooks/useAppointmentFilters";

interface AppointmentFiltersProps {
  filterStatus: string;
  setFilterStatus: (status: string) => void;
  filterType: string;
  setFilterType: (type: string) => void;
  hasActiveFilters?: boolean;
  onClearFilters?: () => void;
}

export const AppointmentFilters: React.FC<AppointmentFiltersProps> = ({
  filterStatus,
  setFilterStatus,
  filterType,
  setFilterType,
  hasActiveFilters,
  onClearFilters,
}) => {
  const { appointmentStatuses, providedServices } = useAppointmentFilters();
  const { t } = useTranslation();
  return (
    <div className="flex items-end gap-4 mt-4">
      <div className="flex-1 grid grid-cols-1 gap-4 md:grid-cols-3">
        <Select
          value={filterStatus}
          onChange={(value) => {
            setFilterStatus(value as string);
          }}
          options={appointmentStatuses}
        />
        <Select
          value={filterType}
          onChange={(value) => {
            setFilterType(value as string);
          }}
          options={providedServices}
        />
      </div>
      {hasActiveFilters && onClearFilters && (
        <Button variant="ghost" onClick={onClearFilters}>
          <X className="mr-2 w-4 h-4" />
          {t("appointment.manage.clearFilters")}
        </Button>
      )}
    </div>
  );
};
